import React from "react";
import PropTypes from "prop-types";
import { Button, Card, Icon } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { BackOfficeRoutes } from "@routes/urls";
import { DocumentCard } from "@modules/Document/DocumentCard";

export const DocumentLabelsSelectedCard = ({ document, onRemoveDocument }) => {
  return (
    <Card className="document-labels-selected-card">
      <Card.Content>
        <Button
          icon
          circular
          size="large"
          className="document-label-selected-button-minus"
          onClick={() => onRemoveDocument(document)}
          color="red"
        >
          <Icon name="minus" />
        </Button>
        <Button
          icon
          circular
          size="large"
          as={Link}
          to={BackOfficeRoutes.documentEditFor(document.pid)}
          color="blue"
          className="document-label-selected-button-edit"
        >
          <Icon name="edit" />
        </Button>
        <DocumentCard data={{ metadata: document }} />
      </Card.Content>
    </Card>
  );
};

DocumentLabelsSelectedCard.propTypes = {
  document: PropTypes.object.isRequired,
  onRemoveDocument: PropTypes.func.isRequired,
};
